module.exports = __webpack_public_path__ + "img/6-full-md.54e96b27.jpg";